// extracted by mini-css-extract-plugin
export default {"quote":"Quote_quote__43vzD","quoteContents":"Quote_quoteContents__pSLU-"};